var $c42af6159e6cf5c7$exports = {};
$c42af6159e6cf5c7$exports = {
    "breadcrumbs": `\u{41D}\u{430}\u{432}\u{456}\u{433}\u{430}\u{446}\u{456}\u{439}\u{43D}\u{430} \u{441}\u{442}\u{435}\u{436}\u{43A}\u{430}`
};


export {$c42af6159e6cf5c7$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
